import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Amplify } from 'aws-amplify';
import { HashRouter } from 'react-router-dom';
import amplifyConfig from './config/amplifyConfig';

// Configure Amplify
try {
  console.log('Configuring Amplify with:', amplifyConfig);
  Amplify.configure(amplifyConfig);
} catch (error) {
  console.error('Failed to configure Amplify:', error);
}

ReactDOM.render(
  <React.StrictMode>
    <HashRouter>
      <App />
    </HashRouter>
  </React.StrictMode>,
  document.getElementById('root')
);

reportWebVitals();